const SESSION_KEY = 'crmSessionToken';
const SESSION_ACTOR_KEY = 'crmSessionActor';

export const isCrmPortalMode = () => {
    if (typeof window === 'undefined') return false;
    const pathname = window.location.pathname || '';
    return pathname.startsWith('/crm-portal');
};

export const crmBasePath = () => {
    if (typeof window === 'undefined') return '/franchise-dashboard/leads/crm';
    const pathname = window.location.pathname || '';
    if (pathname.startsWith('/crm-portal')) return '/crm-portal/app';
    if (pathname.startsWith('/CRM/franchise-crm')) return '/CRM/franchise-crm';
    return '/franchise-dashboard/leads/crm';
};

export const crmApiBase = () => (
    isCrmPortalMode() ? '/api/crm-portal' : '/api/crm'
);

export const getCrmSessionToken = () => {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(SESSION_KEY);
};

export const setCrmSessionToken = (token) => {
    if (typeof window === 'undefined') return;
    if (!token) return;
    window.localStorage.setItem(SESSION_KEY, token);
};

export const setCrmSessionActor = (actor) => {
    if (typeof window === 'undefined') return;
    if (!actor || typeof actor !== 'object') return;
    window.localStorage.setItem(SESSION_ACTOR_KEY, JSON.stringify(actor));
};

export const getCrmSessionActor = () => {
    if (typeof window === 'undefined') return null;
    const raw = window.localStorage.getItem(SESSION_ACTOR_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return parsed;
    } catch {
        return null;
    }
};

export const clearCrmSessionActor = () => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(SESSION_ACTOR_KEY);
};

export const clearCrmSessionToken = () => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(SESSION_KEY);
    window.localStorage.removeItem(SESSION_ACTOR_KEY);
};

export const dashboardPath = () => `${crmBasePath()}/dashboard`;
export const leadsPath = () => `${crmBasePath()}/leads`;
export const leadPath = (id) => `${crmBasePath()}/leads/${id}`;
export const contactsPath = () => `${crmBasePath()}/contacts`;
export const contactPath = (id) => `${crmBasePath()}/contacts/${id}`;
export const dealsPath = () => `${crmBasePath()}/deals`;
export const dealPath = (id) => `${crmBasePath()}/deals/${id}`;
export const activitiesPath = () => `${crmBasePath()}/activities`;
export const leadSourcesPath = () => `${crmBasePath()}/lead-sources`;
export const teamPath = () => `${crmBasePath()}/team`;
export const automationsPath = () => `${crmBasePath()}/automations`;
